/**
 * Decode a URL query value from searchParams.get().
 * Handles + as space and valid %XX sequences; leaves literal % when decoding would throw.
 */
export function safeDecodeQueryParam(value) {
  if (!value) return value;
  const normalized = value.replace(/ /g, '+');
  try {
    return decodeURIComponent(normalized);
  } catch {
    return normalized;
  }
}
